import React from "react";
import { useStore } from "../store";
import Section from "../components/section/section";
import HexagonButton from "../components/hexagon-button/hexagon-button";
import Hexagon1 from "../components/hexagon-1";
import Hexagon2 from "../components/hexagon-2";

export default function EndFrame70() {
  const { section, setSection, showEndFrame, setShowEndFrame } = useStore();

  const watchedSections = React.useMemo(() => {
    return (
      JSON.parse(window.localStorage.getItem(`kasperskey.watchedSections`)) ??
      []
    );
  }, [section]);

  if (section !== 7.0 || !showEndFrame) return null;

  return (
    <Section name="7-0">
      <HexagonButton
        onClick={() => {
          localStorage.clear();
          setSection(1.0);
        }}
      >
        <div className="hexagon-button-flex">
          <img
            src="./assets/replay.png"
            className="Shape__icon Shape__icon--replay"
          />
          Replay the
          <br /> Experience
        </div>
        <Hexagon1 />
      </HexagonButton>
      <HexagonButton
        onClick={() => {
          window.open(
            "https://www.kaspersky.com/blog/own-your-future/37609/?utm_source=interactive-video&utm_medium=partner&utm_campaign=gl_ownyourfuture-2021_sl0099&utm_content=link&utm_term=gl_interactive-video_organic_mden6cgkhmpxv99"
          );
        }}
        //disabled={watchedSections.includes(6.2)}
      >
        <div>
          Read the
          <br /> Own Your Future
          <br /> Report here
        </div>
        <Hexagon2 />
      </HexagonButton>
    </Section>
  );
}
